<template>
  <div>
    <div class="stem">
      <span class="index">{{ idx }}.</span>
      <p class="question_title" v-html="question.question"></p>
      <b class="question_score">{{ question.score }}分</b>
    </div>
    <div class="one_option" :class="{ checked: isInArray(answerList, i.tag) }" v-for="i in question.optionList"
      :key="i.tag">
      <div class="option" @click="chooseQuestion(i)"></div>
      <div class="option_text">
        <span style="margin-right:5px;">{{i.tag}}.</span>
        <span v-html="i.option"></span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "multiple",
    props: {
      // 索引
      idx: {
        type: Number,
        default: null,
      },
      // 题目对象
      question: {
        type: Object,
        default: function () {
          return {};
        },
      },
      historyAnswer: {
        type: String,
        default: "",
      },
    },
    methods: {
      // 判断是否已存在在数组中
      isInArray(arr, item) {
        return arr.some((e) => e === item);
      },
      // 选择正确答案
      chooseQuestion(item) {
        if (this.isInArray(this.answerList, item.tag)) {
          let index = this.answerList.indexOf(item.tag);
          this.answerList.splice(index, 1);
        } else {
          this.answerList.push(item.tag);
        }
        let tagArr = [...this.answerList];
        let answer = {};
        answer[item.questionId] = tagArr.join(",");
        this.$emit("chooseAnswer", answer);
      },
    },
    data() {
      return {
        answerList: [],
      };
    },
    created() {
      // this.answerList = this.historyAnswer.split(",");
      if (this.historyAnswer !== '') {
        this.answerList = this.historyAnswer.split(",");
        let tagArr = [...this.answerList];
        let answer = {};
        answer[this.question.questionId] = tagArr.join(",");
        this.$emit("chooseAnswer", answer);
      }
    },
  };
</script>

<style lang="less" scoped>
  .stem {
    margin: 20px 0;

    .index {
      display: inline-block;
      margin-top: 3px;
      font-size: 16px;
      vertical-align: top;
    }

    .question_title {
      display: inline-block;
      max-width: 90%;
      font-size: 16px;
      color: #333;
      vertical-align: top;
      // img {
      //   margin: 0 5px !important;
      //   max-height: 30px !important;
      // }
    }

    .question_score {
      display: inline-block;
      margin-left: 20px;
      color: #999;
      font-size: 14px;
      vertical-align: top;
    }
  }

  .one_option {
    margin-bottom: 20px;

    &.checked {
      .option {
        position: relative;
        background: #1890FF;
        color: #fff;
        border-color: #1890FF !important;
        transition: all .3s ease;

        &::before {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          content: '✔',
        }
      }

      .option_text {
        color: #1890FF;
      }
    }

    .option {
      display: inline-block;
      width: 20px;
      text-align: center;
      line-height: 20px;
      height: 20px;
      border-radius: 2px;
      border: 1px solid #bbb;
      vertical-align: top;
      cursor: pointer;
    }

    .option_text {
      display: inline-block;
      font-size: 16px;
      margin-left: 16px;
      transition: all .3s ease;

      img {
        margin: 0 5px !important;
        max-height: 30px !important;
      }
    }
  }
</style>